import React, { useState, useRef, useEffect } from 'react';
import { Form, Input, Button, Spin } from 'antd';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import '../Css/Login.css';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  
  const isMounted = useRef(true);
  
  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleSubmit = async () => {
    if (!username || !password) {
      Swal.fire({
        title: 'Campos obrigatórios!',
        text: 'Preencha todos os campos antes de continuar.',
        icon: 'warning',
        confirmButtonText: 'OK'
      });
      return;
    }

    setLoading(true);

    try {
      let response;
      try {
        // Primeiro tenta HTTPS (normal)
        response = await axios.post(
          `${process.env.REACT_APP_API_URL}/login`,
          { identifier: username, password, platform: "lotoqi" },
          { withCredentials: true }
        );
      } catch (error) {
        // Se der erro de certificado vencido, tenta com HTTP
        if (error.code === "ERR_NETWORK" && error.message.includes("ERR_CERT_DATE_INVALID")) {
          console.warn("⚠️ Certificado inválido! Tentando via HTTP...");
          const apiUrlHttp = process.env.REACT_APP_API_URL.replace("https://", "http://");
          response = await axios.post(
            `${apiUrlHttp}/login`,
            { identifier: username, password, platform: "lotoqi" },
            { withCredentials: true }
          );
        } else {
          throw error; // Se for outro erro, repassa
        }
      }

      // Salva o usuário completo vindo do backend!
      if (response.data && response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
      } else {
        console.warn('A resposta do backend não contém o campo user:', response.data);
      }

      // Salva o token
      localStorage.setItem('token', response.data.token);

      Swal.fire({
        title: 'Login realizado!',
        text: 'Seja bem-vindo!',
        icon: 'success',
        confirmButtonText: 'OK'
      });

      // Redireciona para a página do dashboard
      navigate('/dashboard');
      
    } catch (error) {
      console.error('Erro no login', error);

      if (error.response) {
        switch (error.response.status) {
          case 401:
            Swal.fire({
              title: 'Erro de autenticação!',
              text: 'Usuário ou senha incorretos.',
              icon: 'error',
              confirmButtonText: 'Tentar novamente'
            });
            break;
          case 403:
            Swal.fire({
              title: 'Acesso negado!',
              text: 'Seu usuário não tem permissão para acessar o sistema.',
              icon: 'error',
              confirmButtonText: 'Fechar'
            });
            break;
          case 500:
            Swal.fire({
              title: 'Erro no servidor!',
              text: 'Ocorreu um problema interno. Tente novamente mais tarde.',
              icon: 'error',
              confirmButtonText: 'Fechar'
            });
            break;
          default:
            Swal.fire({
              title: 'Erro desconhecido!',
              text: 'Algo deu errado. Tente novamente.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
        }
      } else if (error.request) {
        Swal.fire({
          title: 'Erro de conexão!',
          text: 'Não foi possível conectar ao servidor. Verifique sua internet.',
          icon: 'warning',
          confirmButtonText: 'Tentar novamente'
        });
      } else {
        Swal.fire({
          title: 'Erro inesperado!',
          text: 'Ocorreu um erro desconhecido. Por favor, tente novamente.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  return (
    <div className="login-container">
      <div className="login-form-box">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: 20 }}>
          <img
            src="/img/Vinkings1_logo_92x92.png"
            alt="Logo Vikings"
            style={{ width: 92, height: 92 }}
          />
        </div>
        <h2 className="login-title">Vikings da sorte</h2>

        <Form
          name="login"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={handleSubmit}
          autoComplete="off"
        >
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Por favor, insira seu nome de usuário!' }]}
          >
            <Input
              prefix={<UserOutlined style={{ color: 'rgba(0,0,0,.45)' }} />}
              placeholder="Usuário"
              onChange={e => setUsername(e.target.value)}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Por favor, insira sua senha!' }]}
          >
            <Input.Password
              prefix={<LockOutlined style={{ color: 'rgba(0,0,0,.45)' }} />}
              placeholder="Senha"
              onChange={e => setPassword(e.target.value)}
            />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" disabled={loading} block>
              {loading ? <Spin size="small" /> : 'Login'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default Login;
